var render, staticRenderFns
import script from "./ElSTable.vue?vue&type=script&lang=js"
export * from "./ElSTable.vue?vue&type=script&lang=js"
import style0 from "./ElSTable.vue?vue&type=style&index=0&id=2dbff248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbff248",
  null
  
)

export default component.exports